import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { styled, useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'

import {
  adminGetMemberHistoryList,
} from '@store/admin/member'
import {tableCellClasses} from "@mui/material/TableCell";

const columns = [
  { id: 'updateDateTime', label: '수정일' },
  { id: 'name', label: '성명' },
  { id: 'birth', label: '생년월일' },
  { id: 'position', label: '직책' },
  { id: 'signExpectDate', label: '선임(예정)일' },
  { id: 'reSignExpectDate', label: '사임(예정)일' },
  { id: 'personalInfoAgreeName', label: '개인정보 동의서', isAttach: true },
  { id: 'noloanAgreeName', label: '대출 불가 확약서', isAttach: true },
  { id: 'corporateRegistrationName', label: '법인등기부등본' },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#eee',
    color: '#000',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))

const StyledDialogContent = styled(DialogContent)({
  backgroundColor: '#fdfdfd',
})

const Modal = ({
  data,
  open,
  closeModal
}) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const dispatch = useDispatch()
  const {
    adminMemberHistoryList,
  } = useSelector(store => store.memberAdmin)

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') {
      return
    }
    closeModal()
  }

  //이력호출
  useEffect(() => {
    if (data) {
      dispatch(adminGetMemberHistoryList({
        companyMemberCode: data,
      }))
    }
  }, [ dispatch, data ])

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'xl'}
    >
      <DialogTitle id="responsive-dialog-title">
        특수관계인 이력
      </DialogTitle>
      <StyledDialogContent>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {
                  columns.map((column, index) => (
                    <StyledTableCell
                      key={index}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </StyledTableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                adminMemberHistoryList
                  .map((memberHistory, index) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        {
                          columns.map((column) => {
                            let value = memberHistory[column.id];
                            if (column.isAttach) {
                              value = memberHistory.attachInfo ? memberHistory.attachInfo[column.id] : ''
                            }

                            return (
                              <TableCell key={column.id}>
                                {value}
                              </TableCell>
                            );
                          })
                        }
                      </TableRow>
                    );
                  })
              }
            </TableBody>
          </Table>
        </TableContainer>
      </StyledDialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Modal